module.exports = __webpack_public_path__ + "static/media/game-board-alt.9d91a554.svg";